export default "__VITE_ASSET__7eda96fb__"